import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import CampaignReport from '@/components/campaign-report'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'

export const Route = createFileRoute('/_auth/campaign/report')({
  beforeLoad: ({ location }) =>
    navigateGuard(location, [
      UserRole.ADMINISTRATOR,
      UserRole.SUPERVISOR,
      UserRole.TEAM_LEADER,
    ]),
  component: () => <CampaignsReportWrapper />,
})

function CampaignsReportWrapper() {
  return (
    <Layout.Body>
      <CampaignReport />
    </Layout.Body>
  )
}
